import request from '@utils/axiosWrapper';
import moment from 'moment';

import { RawOrderBaseInfo } from '../../shared/types';
import { OrderBaseInfo } from '../../wmOrder/types';

/** 根据门店ID、用户ID查询订单，用于从IM聊天窗口发起的搜索 */
const searchOrderByUserIdWmPoiId = (params: {
    userId: string;
    requestWmPoiId: string;
    lastLabel: string;
    nextLabel: string;
}) => {
    const requestUrl = '/gw/v2/order/history/r/query/common';
    return request
        .rawGet<{
            code: number;
            lastLabel: string;
            nextLabel: string;
            wmOrderList: OrderBaseInfo[] | RawOrderBaseInfo[];
            msg?: string;
        }>(requestUrl, {
            params: {
                ...params,
                getNewVo: 1,
                wmOrderPayType: '-2',
                wmOrderStatus: '-2',
                sortField: '2',
                startDate: moment()
                    .subtract(6, 'days')
                    .format('YYYY-MM-DD'),
                endDate: moment().format('YYYY-MM-DD'),
            },
        })
        .then(response => {
            if (response.code !== 0) {
                throw Error(response.msg || '网络异常，请稍后再试');
            }

            return response;
        });
};

/** 通过关键字搜索历史订单【新】 */
const searchOrderByKeywordNew = (params: {
    pageNum: number;
    pageSize: number;
    searchItem: string;
    /** 排序:0-降序1-升序 */
    sortType: number;
    /** 标签查询的标签code */
    code: number;
}) => {
    const requestUrl = '/gw/api/order/mix/search/common';

    return request
        .rawPostAsFormSubmit<{
            data: {
                pageCount: number;
                totalCount: number;
                wmOrderList: OrderBaseInfo[] | RawOrderBaseInfo[];
            };
            msg: string;
            code: number;
            serverTime: number;
        }>(requestUrl, { ...params })
        .then(response => {
            if (response.code !== 0) {
                throw Error(response.msg || '网络异常，请稍后再试');
            }

            return response;
        });
};

/** 根据门店ID、用户ID查询订单，用于从IM聊天窗口发起的搜索 */
const searchOrderByUserIdWmPoiIdNew = (params: {
    userId: string;
    wmPoiId: string;
    lastLabel: string;
    nextLabel: string;
}) => {
    const requestUrl = '/gw/api/order/mix/history/list/common';
    return request
        .rawPostAsFormSubmit<{
            data: {
                pageCount: number;
                totalCount: number;
                wmOrderList: OrderBaseInfo[] | RawOrderBaseInfo[];
                /** 返回空字符串时表示上一页无数据，否则返回一个对象 */
                lastLabel: object | string;
                /** 返回空字符串时表示下一页无数据，否则返回一个对象 */
                nextLabel: object | string;
            };
            msg: string;
            code: number;
            serverTime: number;
        }>(requestUrl, {
            ...params,
            tag: 'all',
            sortField: '2',
            startDate: moment()
                .subtract(6, 'days')
                .format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
        })
        .then(response => {
            if (response.code !== 0) {
                throw Error(response.msg || '网络异常，请稍后再试');
            }

            return response;
        });
};

export { searchOrderByUserIdWmPoiId, searchOrderByKeywordNew, searchOrderByUserIdWmPoiIdNew };
